import React from "react";
import style from "./button.module.css";
import { Loadingbtn } from "../loading/Loading";
interface Iprop {
  className?: string;
  dice?: boolean;
  arrow?: boolean;
  disable?: boolean;
  onclick: () => void;
  text: string;
  loading?: boolean;
  outlline?: boolean;
  share?: boolean;
  isSpecial?: boolean;
}
const Button: React.FC<Iprop> = ({
  className,
  dice,
  arrow,
  disable,
  onclick,
  text,
  loading,
  outlline,
  share,
  isSpecial,
}) => {
  const diceIcon = `${process.env.PUBLIC_URL}/assets/icon/dice-gold.svg`;
  const arrowIcon = `${process.env.PUBLIC_URL}/assets/icon/arrow-left-gold.svg`;
  const shareIcon = `${process.env.PUBLIC_URL}/assets/icon/share.svg`;
  return (
    <button
      className={`${style.button} ${outlline ? style.outline : ""} ${
        className ? className : ""
      } ${isSpecial ? style.special : ""}`}
      onClick={onclick}
      disabled={disable}
    >
      {!loading && <span> {text}</span>}
      {dice && !loading && (
        <img className={style.img} src={diceIcon} alt="diceIcon" />
      )}
      {arrow && !loading && (
        <img className={style.img} src={arrowIcon} alt="arrowIcon" />
      )}
      {share && <img className={style.img} src={shareIcon} alt="shareIcon" />}
      {loading && <Loadingbtn />}
    </button>
  );
};

export default Button;
